import React, { useEffect, useState, useCallback, useRef } from "react";
import cn from "classnames";
import styles from "./ViewFirmware.module.scss";
import Master from "screen/Master";

var id = undefined;
var view = undefined;

function firmwareEdit(props) {
  view = props?.match?.params?.view;
  id = props?.match?.params?.id;

  const firmwareData1 = props.location.state.firmwareData;
  const selectedFirmware =
    firmwareData1.find((item) => item.firmwareID === id) || {};

  return (
    <>
      <div className={cn(styles.flex_item)}>
        <h2>Firmware OTA</h2>
        <h3>&gt;</h3>
        <h3>Edit Firmware Details</h3>
      </div>
      <div className={cn(styles.flex_item1)}>
        <h1>Edit Firmware Details</h1>
        <div className={cn(styles.Delete_block)}>
          <img
            src={require("assets/DeleteIcon.svg").default}
            alt="Rectangle 16663"
          />
          <p>Delete Firmware</p>
        </div>
      </div>
      <div className={cn(styles.block1)}>
       <div className={cn(styles.block1_layout)}>
         <div className={cn(styles.formBlock)}>
          <div className={cn(styles.formBlock1)}>
            <div className={cn(styles.block3, styles.block3_layout)}>
              <div className={cn(styles.text_body, styles.text_body_layout)}>
                {"Firmware ID*"}
              </div>
              <input
                name="FirmwareID"
                className={cn(styles.line1, styles.line1_layout)}
                value={selectedFirmware.firmwareID}
                maxLength="50"
              />
            </div>
            <div className={cn(styles.block3, styles.block3_layout)}>
              <div className={cn(styles.text_body, styles.text_body_layout)}>
                {"Model*"}
              </div>
              <input
                name="Model"
                className={cn(styles.line1, styles.line1_layout)}
                value={selectedFirmware.model}
                maxLength="50"
              />
            </div>
          </div>
          <div className={cn(styles.formBlock1)}>
            <div className={cn(styles.block3, styles.block3_layout)}>
              <div className={cn(styles.text_body, styles.text_body_layout)}>
                {"Released On*"}
              </div>
              <div className={styles.dateInputContainer}>
                <input
                  name="Day"
                  className={cn(styles.line2, styles.line2_layout)}
                  maxLength="2"
                  placeholder="dd"
                />
                <span className={styles.dateSeparator}>/</span>
                <input
                  name="Month"
                  className={cn(styles.line2, styles.line2_layout)}
                  maxLength="2"
                  placeholder="mm"
                />
                <span className={styles.dateSeparator}>/</span>
                <input
                  name="Year"
                  className={cn(styles.line2, styles.line2_layout)}
                  maxLength="4"
                  placeholder="yyyy"
                />
              </div>
            </div>
            <div className={cn(styles.block3, styles.block3_layout)} style={{marginTop:"12px"}}>
              <div className={cn(styles.text_body, styles.text_body_layout)}>
                {"Size*"}
              </div>
              <input
                name="Size"
                className={cn(styles.line1, styles.line1_layout)}
                value={selectedFirmware.size}
                maxLength="50"
              />
            </div>
          </div>
          <div className={cn(styles.formBlock1)}>
            <div className={cn(styles.formBlock2)}>
              <div className={cn(styles.block3, styles.block3_layout)}>
                <div className={cn(styles.text_body, styles.text_body_layout)}>
                  {"Firmware Version*"}
                </div>
                <input
                  name="Version"
                  className={cn(styles.line1, styles.line1_layout)}
                  value={selectedFirmware.version}
                  maxLength="50"
                />
              </div>
              <div className={cn(styles.block3, styles.block3_layout)}>
                <div className={cn(styles.text_body, styles.text_body_layout)}>
                  {"Manufacturer*"}
                </div>
                <input
                  name="manufacturer"
                  className={cn(styles.line1, styles.line1_layout)}
                  value={selectedFirmware.firmwareID}
                  maxLength="50"
                />
              </div>
            </div>
            <div className={cn(styles.block3, styles.block3_layout)}>
              <div className={cn(styles.text_body, styles.text_body_layout)}>
                {"Release Note*"}
              </div>
              <textarea
              style={{width:"200%"}}
                name="ReleaseNote"
                className={cn(styles.line1, styles.line1_layout)}
                maxLength="100"
              />
            </div>
          </div>
        </div>
        <div className={cn(styles.block4)} >
           <div className={cn(styles.block4_heading)}>
           <h5>Firmware File</h5>
           <img
           style={{paddingLeft:"5px"}}
            src={require("assets/Information.svg").default}
            alt="Rectangle 16663"
          />
           </div>
           <button className={cn(styles.block4_button)}>
           <img
           style={{paddingRight:"8px"}}
            src={require("assets/Swapme.svg").default}
            alt="Rectangle 16663"
          />
          Change Firmware
           </button>
           <div className={cn(styles.block4_button1)}>
           <div className={cn(styles.block4_item)}>
           <img
           style={{paddingRight:"10px"}}
            src={require("assets/Prefix.svg").default}
            alt="Rectangle 16663"
          />
          <p>Filename.format</p>
           </div>
          <img
           style={{height:"20px",width:"12px"}}
            src={require("assets/CloseBlueButton.svg").default}
            alt="Rectangle 16663"
          />

           </div>
        </div>
       </div>
      </div>

      <div style={{ display: "flex" }}>
        <div className={cn(styles.flex2_spacer3)} />
        <div>
          <button className={cn(styles.Download_button)}>Submit Details</button>
        </div>
      </div>
    </>
  );
}

export default function EditFirmware(props) {
  return (
    <>
      <Master opts={props} screen={firmwareEdit} showStatus={false} />
    </>
  );
}

EditFirmware.inStorybook = true;
